import React, { memo } from 'react';
import { setup } from '../config';
import styled from 'styled-components';
import arrowLeft from '../assets/page-arrow-left.svg';
import arrowRight from '../assets/page-arrow-right.svg';
import arrowLeftFirst from '../assets/page-arrow-left-first.svg';
import arrowRightLast from '../assets/page-arrow-right-last.svg';

const { maxNumberOfEvents } = setup;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 600px;
  > div:nth-child(2) {
    margin-left: 16px;
  }
  > div:nth-child(4) {
    margin-right: 16px;
  }
`;

const Indicator = styled.div`
  color: #828282;
  font-size: 16px;
  margin: 0 48px;
`;

const IconContainer = styled.div`
  cursor: pointer;
`;

function Pagination({
  total,
  page,
  onClickPage,
}) {
  const lastPage = Math.ceil(total/maxNumberOfEvents);

  const onClickHandler = ({
    action
  }) => {
    switch(action) {
      case 'first':
        onClickPage({
          targetPage: 1,
        });
        break;

      case 'next':
        if (page + 1 <= lastPage) onClickPage({
          targetPage: page + 1,
        });
        break;

      case 'previous':
        if (page - 1 >= 1) onClickPage({
          targetPage: page - 1,
        });
        break;

      case 'last':
        onClickPage({
          targetPage: lastPage,
        });
        break;

      default:
        break;
    }
  }

  return (
    <Container>
      <IconContainer
        onClick={(e) => {
          onClickHandler({
            action: 'first'
          })
        }}
      >
        <img
          src={arrowLeftFirst}
          alt="pagination go to first page"
        />
      </IconContainer>
      <IconContainer
        onClick={() => {
          onClickHandler({
            action: 'previous'
          })
        }}
      >
        <img
          src={arrowLeft}
          alt="pagination go to previous page"
        />
      </IconContainer>
      <Indicator>
        {`${page} of ${lastPage}`}
      </Indicator>
      <IconContainer
        onClick={() => {
          onClickHandler({
            action: 'next'
          })
        }}
      >
        <img
          src={arrowRight}
          alt="pagination go to next page"
        />
      </IconContainer>
      <IconContainer
        onClick={() => {
          onClickHandler({
            action: 'last'
          })
        }}
      >
        <img
          src={arrowRightLast}
          alt="pagination go to last page"
        />
      </IconContainer>
    </Container>
  )
}

export default memo(Pagination);
